module.exports = __webpack_public_path__ + "media/intro_dang.a687b6ad.mp3";